<div class="modal-header row-header si-dialog__header" [class.si-dialog__header--with-meta]="dialogHeaderMetaTemplate" *ngIf="!hideHeader">
	<div class="modal-title si-dialog__title">
		<ng-container [ngSwitch]="headerLevel">
			<h1 *ngSwitchCase="1" class="mb-0">{{ header }}</h1>
			<h2 *ngSwitchCase="2" class="mb-0">{{ header }}</h2>
			<h3 *ngSwitchCase="3" class="mb-0">{{ header }}</h3>
			<h4 *ngSwitchCase="4" class="mb-0">{{ header }}</h4>
			<h5 *ngSwitchCase="5" class="mb-0">{{ header }}</h5>
			<h6 *ngSwitchCase="6" class="mb-0">{{ header }}</h6>
			<h2 *ngSwitchDefault class="mb-0">{{ header }}</h2>
		</ng-container>
		<p *ngIf="subheader" class="si-dialog__subheader">{{ subheader }}</p>
	</div>
	<div *ngIf="dialogHeaderMetaTemplate" class="si-dialog__header-meta">
		<ng-container *ngTemplateOutlet="dialogHeaderMetaTemplate"></ng-container>
	</div>
  <button *ngIf="!hideCloseButton" mat-icon-button class="close si-dialog__close" aria-label="Close" (click)="onClose()">
    <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
  </button>
</div>
<mat-progress-bar class="absolute w-full si-dialog__progress" *ngIf="isLoading"></mat-progress-bar>
<mat-dialog-content class="row-content si-dialog__content">
	<div class="si-dialog__body" [ngClass]="modalBodyClasses">
		<ng-container *ngIf="dialogBodyTemplate">
			<ng-container *ngTemplateOutlet="dialogBodyTemplate"></ng-container>
		</ng-container>
	</div>
</mat-dialog-content>
<mat-dialog-actions
	class="row-actions si-dialog__footer"
	[class.si-dialog__footer--custom]="dialogFooterTemplate"
	[class.si-dialog__footer--default]="!dialogFooterTemplate"
	[ngClass]="modalFooterClasses"
	*ngIf="!hideFooter"
>
	<ng-container *ngIf="dialogFooterTemplate; else defaultFooterTemplate">
		<ng-container *ngTemplateOutlet="dialogFooterTemplate"></ng-container>
	</ng-container>

	<ng-template #defaultFooterTemplate>
		<div class="si-dialog__footer-group">
      <div>
        <button *ngIf="!hideCancelButton" matButton="outlined" type="button" (click)="onClose()">{{ cancelButtonText }}</button>
      </div>
      <button
				*ngIf="!hideSaveButton"
				matButton="filled"
				type="button"
				[disabled]="saveButtonDisabled"
				[ngClass]="saveButtonClass"
				(click)="onSave()"
			>{{ saveButtonText }}</button>
		</div>
	</ng-template>
</mat-dialog-actions>
